var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.coLoader
    ? _c(
        "v-container",
        { staticClass: "px-5 py-0" },
        [
          _c(
            "v-layout",
            { attrs: { fluid: "" } },
            [
              _c(
                "v-flex",
                { attrs: { "text-xs-center": "" } },
                [
                  _c(
                    "v-container",
                    { staticClass: "pa-0", attrs: { "fill-height": "" } },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            transition: "slide-y-transition",
                            "offset-y": "",
                            top: "",
                            bottom: "",
                            disabled: _vm.plusButtonVisible
                          },
                          model: {
                            value: _vm.dtMenuIsOpened,
                            callback: function($$v) {
                              _vm.dtMenuIsOpened = $$v
                            },
                            expression: "dtMenuIsOpened"
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ml-0 plus-button",
                              attrs: {
                                slot: "activator",
                                color: _vm.dtMenuIsOpened
                                  ? "secondary"
                                  : "primary",
                                fab: "",
                                dark: "",
                                small: ""
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("add")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            [
                              _vm._l(_vm.dtActions, function(ac, i) {
                                return _vm.checkVisible(ac.key, ac.secondaryKey)
                                  ? [
                                      ac.isAllowed
                                        ? _c(
                                            "v-list-tile",
                                            {
                                              staticClass:
                                                "pointer sub-action-pointer",
                                              attrs: {
                                                disabled: _vm.disabled(
                                                  ac.key,
                                                  ac.secondaryKey
                                                )
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.handleMenuClick(ac)
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-list-tile-avatar",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "primary"
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(ac.icon))]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-list-tile-title", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(ac.translationKey)
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.checkActionVisible(i) && ac.isAllowed
                                        ? _c("v-divider", {
                                            staticClass: "secondary",
                                            class:
                                              i === _vm.dtActions.length - 2
                                                ? "secondary--separator"
                                                : "",
                                            attrs: { inset: "" }
                                          })
                                        : _vm._e()
                                    ]
                                  : _vm._e()
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { "d-flex": "", xs12: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "pt-1 pb-3 pr-1",
                          attrs: { "fill-height": "", fluid: "" }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { "fill-height": "", row: "", wrap: "" } },
                            [
                              _c("v-textarea", {
                                ref: "editorRef",
                                attrs: {
                                  placeholder: "Tapez votre texte ici",
                                  readonly: !_vm.$route.meta.send_message,
                                  "multi-line": "",
                                  "full-width": "",
                                  "hide-details": "",
                                  rows: "2"
                                },
                                on: {
                                  keypress: [
                                    function($event) {
                                      if (
                                        !("button" in $event) &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      if (!$event.shiftKey) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      if (
                                        $event.ctrlKey ||
                                        $event.altKey ||
                                        $event.metaKey
                                      ) {
                                        return null
                                      }
                                      return _vm.handleBreakLine($event)
                                    },
                                    function($event) {
                                      if (
                                        !("button" in $event) &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      if (
                                        $event.ctrlKey ||
                                        $event.shiftKey ||
                                        $event.altKey ||
                                        $event.metaKey
                                      ) {
                                        return null
                                      }
                                      return _vm.handleSendMessage($event)
                                    }
                                  ]
                                },
                                model: {
                                  value: _vm.dtMessage,
                                  callback: function($$v) {
                                    _vm.dtMessage = $$v
                                  },
                                  expression: "dtMessage"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "sendmessage-button primary white--text",
                                  staticStyle: {
                                    height: "100%",
                                    "min-height": "75px",
                                    "border-radius": "5px"
                                  },
                                  attrs: {
                                    disabled: _vm.sendMessageButtonVisible
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.handleSendMessage($event)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(_vm.lblSetting.ticketSendButton)
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("input", {
                            ref: "fileRef",
                            staticClass: "input-file",
                            staticStyle: { display: "none" },
                            attrs: {
                              id: "input-field",
                              multiple: "",
                              type: "file"
                            },
                            on: {
                              change: function($event) {
                                _vm.handleUploadButton($event.target, "image")
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.dtFileError
            ? _c("base-error-dialog", {
                attrs: { error: _vm.dtError },
                on: { cancel: _vm.handleHideError }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("base-notification", {
            attrs: {
              title: _vm.$t(_vm.lblSetting.ticketNotificationTitle),
              message: _vm.$t(_vm.$t(_vm.lblSetting.ticketNotificationMessage))
            },
            on: { confirm: _vm.handleConfirm },
            model: {
              value: _vm.dtNotificationVisible,
              callback: function($$v) {
                _vm.dtNotificationVisible = $$v
              },
              expression: "dtNotificationVisible"
            }
          })
        ],
        1
      )
    : _c("chat-editor-loader")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04bcc1ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04bcc1ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-chat-editor/template.html
// module id = null
// module chunks = 